/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';

export const ShowHide = ({ show = false, children }) => show ? <React.Fragment>{children}</React.Fragment> : null;
